import { Components, Theme } from '@mui/material'

const MuiRadio: Components<Theme>['MuiRadio'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: 0,
      width: 20,
      height: 20,
      background: theme.backgrounds.backgroundFour,
      border: `1px solid ${theme.backgrounds.backgroundOne}`,
      boxShadow: theme.boxShadows.small,

      '&.MuiButtonBase-root': {
        '&.MuiButtonBase-root': {
          color: theme.colors.empty,
          fontSize: 'inherit',
          '.MuiSvgIcon-root': {
            fontSize: 'inherit',
          },
        },
      },
      '&.Mui-checked': {
        border: `3px solid ${theme.colors.green}`,

        '&.MuiButtonBase-root': {
          '.MuiSvgIcon-root': {
            width: 20,
            height: 20,
            border: `6px solid ${theme.colors.green}`,
            borderRadius: '50%',
            color: theme.colors.white,
          },
        },
      },

      '&.Mui-disabled': {
        '&.MuiButtonBase-root': {
          background: theme.colors.grayHover,
        },
        '&.Mui-checked': {
          '&.MuiButtonBase-root': {
            opacity: 0.5,
          },
        },
      },
    }),
  },
}

export default MuiRadio
